__turbopack_context__.v({
  "box": "media-frame-module-scss-module__l41Oca__box",
  "contain": "media-frame-module-scss-module__l41Oca__contain",
  "cover": "media-frame-module-scss-module__l41Oca__cover",
  "label": "media-frame-module-scss-module__l41Oca__label",
  "placeholder": "media-frame-module-scss-module__l41Oca__placeholder",
  "root": "media-frame-module-scss-module__l41Oca__root",
  "sketch": "media-frame-module-scss-module__l41Oca__sketch",
  "sub": "media-frame-module-scss-module__l41Oca__sub",
});
